import { createElement, useRef } from 'react';
import { BusyStateIndicator } from '../BusyStateIndicator';
import { BaseDialog } from '../Dialog/__internal__/';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import bundle from './NovaComponents-BusyStateDialog-gui-icu.properties';
import { BusyStateDialogProps } from '.';

const useTextLocalizer = createUseTextLocalizer(bundle);

export const BusyStateDialog = (props: BusyStateDialogProps) => {
  const localize = useTextLocalizer();
  const busyStateAnimationRef = useRef<HTMLDivElement>(null);

  return (
    <BaseDialog
      testId={props.testId}
      isOpen={props.isOpen}
      title={props.title && props.title.length > 0 ? props.title : localize('dialog.default.title')}
      contentPadding="2rem"
      hideCloseIcon
      dismissAction={
        props.showCancelButton
          ? {
              text: localize('dismiss.button.label'),
              onPress: props.onDismiss,
              ariaLabel: props.cancelAriaLabel,
            }
          : undefined
      }
      onOpen={() => {
        // Since the animiation element might not be mounted yet when the Dialog is open,
        // use setInvertal to wait till the animation element is shown in the DOM
        const intervalId = setInterval(() => {
          if (busyStateAnimationRef.current) {
            busyStateAnimationRef.current.focus();
            clearInterval(intervalId);
          }
        }, 100);
      }}
      size={{ minWidth: '11rem', maxWidth: '24rem', minHeight: '0' }}
      titleWrapText
    >
      <BusyStateIndicator active delay={0} busyStateAnimationRef={busyStateAnimationRef} />
    </BaseDialog>
  );
};
